/**
 * cascade 无限级联表
 * MIT Licensed
 */
layui.define(['jquery', 'layer', 'form', 'api'], function (exports) {
    var $ = layui.jquery, form = layui.form, layer = layui.layer, api = layui.api;
    var cascade = {
        v: '1.0.0',
        config: {},
        setConfig: function (opt) {
            let that = this;
            that.config = $.extend({}, that.config, options);
            return that;
        },
        on: function (events, callback) {
            return layui.onevent.call(this, 'layarea', events, callback);
        }
    };
    thisModule = function () {
        let that = this;
        return {
            cascade: function (files) {
                that.cascade.call(that, files);
            }
            , config: that.config
        }
    };

    Class = function (options) {
        let that = this;
        that.config = $.extend({}, that.config, cascade.config, options);
        that.render();
    };

    Class.prototype.config = {
        elem: '',
        selectList: [],  //下拉级联列表
        selectedList: [],    //已选择项
        fieldName: 'label',  //显示的字段
        fieldValue: 'value', //值字段
        fieldChild: 'children', //子字段
        fieldData: 'data',   //数据字段
        fieldExt:'',  //扩展字段
        empty:'暂无数据',
        data: {},
        url: '',
        change: function (result) { }
    };

    //主体渲染
    Class.prototype.render = function () {
        var that = this, options = that.config;
        //console.log(options);

        //读取全部选择框
        var selectList = $(options.elem).find('select');
        selectList.each(function (index, item) {
            that.config.selectList.push(item.id)
        });

        //加载数据
        api.ajax(options.url, {showResult:false}, {}, function (res) {
            that.config.data = res[that.config.fieldData];
            that.init();
            that.events();
        })
    };

    //初始化第一个下拉数据
    Class.prototype.init = function () {
        var that = this, options = that.config;
        //初始化所有下拉提示文字
        options.selectList.forEach(function (item, index) {
            $("#" + options.selectList[index]).append("<option value=''>" + $("#" + options.selectList[index]).attr('lay-placeholder')+"</option>");
        })
        //加载第一个下拉
        options.data.forEach(function (item) {
            if (item[options.fieldExt]){
                $("#" + options.selectList[0]).append("<option value='" + item[options.fieldValue] + "' data-value='" + item[options.fieldExt] + "'>" + item[options.fieldName] + " - " + item[options.fieldExt] + "</option>");
            }else{
                $("#" + options.selectList[0]).append("<option value='" + item[options.fieldValue] + "'>" + item[options.fieldName] + "</option>");
            }
        });
        //是否有默认值
        selectValue = $("#" + options.selectList[0]).attr('lay-value');
        if (selectValue){
            options.data.forEach(function (item) {
                if (item[options.fieldValue] == selectValue || item[options.fieldName] == selectValue){
                    $("#" + options.selectList[0]).val(item[options.fieldValue]);
                    that.pullData(0,options.selectList[0]);
                }
            })
        }
        form.render();
    };

    //插入数据
    Class.prototype.pullData = function (selectIndex,selectId) {
        var that = this, options = that.config;
        options.selectedList[selectIndex] = $('#' + selectId + ' option:selected').index() - 1; //第一个选择提示的减去
        var obj = options.data;
        //上个选项是否选择了
        if (selectIndex> 0 && (options.selectedList[selectIndex-1]==undefined || options.selectedList[selectIndex-1]==-1)){
            layer.msg("上一个选项还没选择呢");
            return false;
        }

        //找最后一个节点
        for (var i = 0; i <= selectIndex; i++) {
            //判断是否有子菜单
            if (obj[options.selectedList[i]]){
                if (options.fieldChild in obj[options.selectedList[i]]){
                    obj = obj[options.selectedList[i]][options.fieldChild];
                }else{
                    obj=[];
                    break;
                }
            }else{
                obj=[];
                break;
            }
        }
        //找下一个及之后的节点
        if (selectIndex < (options.selectList.length - 1)) {
            //清空之后所有
            for (var i = selectIndex; i < (options.selectList.length - 1); i++) {
                $("#" + options.selectList[i + 1]).empty();
                if (obj.length>0){
                    $("#" + options.selectList[i + 1]).append("<option value=''>" + $("#" + options.selectList[i + 1]).attr('lay-placeholder')+"</option>");
                }else{
                    $("#" + options.selectList[i + 1]).append("<option value=''>"+options.empty+"</option>");
                }
            }
            //加载
            if (obj) {
                //是否有默认值
                selectValue = $("#" + options.selectList[selectIndex + 1]).attr('lay-value');
                obj.forEach(function (item) {
                    //如果有扩展字段，则显示扩展字段
                    if (options.fieldExt){
                        $("#" + options.selectList[selectIndex + 1]).append("<option value='" + item[options.fieldValue] + "' data-value='" + item[options.fieldExt] + "'>" + item[options.fieldName] + " - " + item[options.fieldExt] + "</option>");
                    }else{
                        $("#" + options.selectList[selectIndex + 1]).append("<option value='" + item[options.fieldValue] + "'>" + item[options.fieldName] + "</option>");
                    }
                    if (item[options.fieldValue] == selectValue || item[options.fieldName] == selectValue){
                        $("#" + options.selectList[selectIndex + 1]).val(item[options.fieldValue]);
                        //防止下标溢出
                        if (selectIndex<options.selectList.length){
                            that.pullData(selectIndex+1,options.selectList[selectIndex+1]);
                        }
                    }
                });
            }
            form.render();
        }
    };

    Class.prototype.events = function () {
        var that = this, options = that.config;
        //遍历下拉选择
        options.selectList.forEach(function (item, index) {
            //选择后回调
            if (index<options.selectList.length){
                form.on('select(' + item + ')', function (data) {
                    that.pullData(index,item);
                    that.config.change(data);
                });
            }
        })
    }

    cascade.render = function (options) {
        let inst = new Class(options);
        return thisModule.call(inst);
    };

    exports('cascade', cascade);
});